import { Scissors, Sparkles, Zap, Film, PlayCircle, Phone, HelpCircle, Tv, ArrowRight } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-background text-white">
      {/* Watch Barth & Friends — top banner */}
      <a
        href="/u/barth"
        data-testid="watch-barth-banner"
        className="relative z-20 flex items-center justify-center gap-3 bg-accent px-4 py-3 font-body text-sm font-semibold text-black transition-colors hover:bg-accent/90"
      >
        <Tv className="h-4 w-4" />
        <span>Watch <span className="font-bold">Barth &amp; Friends</span> — full shows &amp; clips</span>
        <ArrowRight className="h-4 w-4" />
      </a>

      <div className="pointer-events-none absolute -left-40 top-[-10%] h-[520px] w-[520px] rounded-full bg-accent/10 blur-[120px]" />
      <div className="pointer-events-none absolute -right-40 bottom-[-10%] h-[520px] w-[520px] rounded-full bg-primary/10 blur-[120px]" />

      <div className="relative mx-auto grid min-h-screen max-w-6xl grid-cols-1 items-center gap-16 px-6 py-16 lg:grid-cols-2">
        <div>
          <div className="flex items-center gap-3">
            <div className="grid h-11 w-11 place-items-center bg-accent">
              <Scissors className="h-5 w-5 text-black" />
            </div>
            <span className="font-mono text-xs uppercase tracking-[0.35em] text-accent">Clip Miner</span>
          </div>

          <h1 className="mt-10 font-display text-5xl leading-[1.05] tracking-tight text-white sm:text-6xl">
            Turn full sets into<br />
            <span className="text-accent">scroll-stopping</span> clips.
          </h1>
          <p className="mt-6 max-w-md font-body text-base text-muted-foreground">
            Drop a full-length show. Clip Miner transcribes it, finds the funniest moments in your
            comedic voice, and cuts vertical, captioned, ready-to-post clips — with active-speaker
            tracking baked in.
          </p>

          <ul className="mt-8 space-y-3 font-body text-sm text-white/90">
            <li className="flex items-center gap-3"><Sparkles className="h-4 w-4 text-accent" /> AI finds the tags that actually land</li>
            <li className="flex items-center gap-3"><Film className="h-4 w-4 text-accent" /> Auto vertical reframe + karaoke captions</li>
            <li className="flex items-center gap-3"><Zap className="h-4 w-4 text-accent" /> A private workspace, your cast roster, your style</li>
          </ul>

          <a
            data-testid="hero-demo-btn"
            href="/demo"
            className="mt-9 inline-flex items-center gap-3 border border-accent bg-accent/10 px-6 py-3.5 font-body text-sm font-semibold text-accent transition-colors hover:bg-accent hover:text-black"
          >
            <PlayCircle className="h-5 w-5" /> Watch the live demo
            <span className="font-mono text-[10px] uppercase tracking-widest opacity-70">real clips, no signup</span>
          </a>
        </div>

        <div className="w-full max-w-md justify-self-center lg:justify-self-end">
          <div className="border border-border bg-card/70 p-8 backdrop-blur">
            <h2 className="font-display text-2xl tracking-wide text-white">Get started</h2>
            <p className="mt-2 font-body text-sm text-muted-foreground">
              Sign in to open your private studio. Free to start — upgrade any time.
            </p>
            <button
              data-testid="google-login-btn"
              onClick={handleLogin}
              className="mt-8 flex w-full items-center justify-center gap-3 bg-white px-5 py-3.5 font-body text-sm font-semibold text-black transition-transform hover:-translate-y-0.5"
            >
              <svg className="h-5 w-5" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
              </svg>
              Continue with Google
            </button>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              No credit card. 2 free shows to start.
            </p>
            <a
              data-testid="see-demo-link"
              href="/demo"
              className="mt-4 flex items-center justify-center gap-2 border border-border py-3 font-body text-sm text-white transition-colors hover:border-accent hover:text-accent"
            >
              See a live demo first
            </a>
          </div>

          {/* Support / contact */}
          <div className="mt-4 border border-border bg-card/50 p-5" data-testid="contact-support">
            <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-accent">
              <HelpCircle className="h-4 w-4" /> Need help or having issues?
            </p>
            <p className="mt-2 font-body text-sm text-muted-foreground">Reach out to <span className="text-white">Scott Burton</span> — happy to help you get set up.</p>
            <a href="tel:+16628013526" data-testid="contact-phone"
               className="mt-3 inline-flex items-center gap-2 border border-accent/50 bg-accent/10 px-4 py-2.5 font-body text-sm font-semibold text-accent transition-colors hover:bg-accent hover:text-black">
              <Phone className="h-4 w-4" /> (662) 801-3526
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
